import { camelizeKeys } from 'humps';

let http;

export const getOEMFeed = ({ makeId, feedDescriptionId }) => http.get(`/feed-builder/display/mockup/${feedDescriptionId}/${makeId}`)
  .then(({ body }) => body.map(row => camelizeKeys(row)));

export default ({ http: _http }) => {
  http = _http;
};



// WEBPACK FOOTER //
// ./src/api-purecars/feed-builder.js